import React from "react";
import config from '../../config';
import { FaCar, FaTrash } from "react-icons/fa";
const SubscriptionCardView = ({ subscription, onDelete,showDelete,styles={} }) => {
  const {
    name_en,
    icon,
    color,
    cost,
    duration_days,
    subscriptionServices,
    number_of_cars
  } = subscription;

  return (
    <div
      className={`relative w-80 h-72 min-w-80  rounded-lg shadow-lg overflow-hidden mt-2 ${styles}`}
      style={{ backgroundColor: color || "#f0f0f0" }}
    >
    
    { showDelete && <div className="absolute top-4 right-4 z-40">
        <button className=" text-white z-50" onClick={(e) => {
          e.stopPropagation(); // Prevent event bubbling
          onDelete(subscription)
        }}>
          <FaTrash />
        </button>
      </div>}

      {/* Name */}
   
      <div className="absolute top-4  text-left w-full px-4" >
      <div className="flex items-end  justify-between">  {/* Duration */}
      <h2 className="text-white text-3xl font-bold tracking-wider w-[50%]">
        {name_en.toUpperCase()}
      </h2>
      <div className="text-white text-sm px-4">
        <span>{duration_days} days</span>
      </div></div>
      <div className="mt-2 h-1 w-full bg-white/30 rounded"></div>
       {/* Services Highlights */}
       <div className=" mt-2 flex items-start  justify-between">
        <ul className="text-sm text-white space-y-1 tracking-wider w-[50%]">
          <h2 className="font-bold">Services</h2>
          {subscriptionServices?.slice(0, 3).map((service, index) => (
            <li key={index} className="truncate">
              • {service.serviceType.name_en}
            </li>          
          ))}
          {subscriptionServices?.length > 3 && <li>• +{subscriptionServices.length - 3} more</li>}
        </ul>
        <div className="text-white text-sm px-4 right-4 font-extrabold flex items-center gap-2 ">
        {number_of_cars } <FaCar /> 
      </div>
      </div>    
    </div>

     
  {/* Icon */}
  <div className="absolute bottom-4 left-4">
        {icon ? (
          <img src={config.apiUrl + icon} alt="Subscription Icon" className="w-12 h-12" />
        ) : (
          <div className="w-12 h-12 bg-gray-200 rounded-full flex items-center justify-center">
            <span className="text-sm text-gray-500">Icon</span>
          </div>
        )}
      </div>
      {/* Cost */}
      <div className="absolute bg-gradient-to-r from-[#F9EED9] to-[#DEB686]  rounded-full p-2 bottom-4 right-4 text-stone-800 text-lg font-extrabold">
        <span> {parseFloat(cost).toFixed(0)} QAR</span>
      </div>
    </div>
  );

};

export default SubscriptionCardView;
